export function formatBoolean(value, trueValue = 'True', falseValue = 'False') {
    return value ? trueValue : falseValue;
}

export function formatYesNo(value) {
    return formatBoolean(value, 'Yes', 'No');
}

export function formatOnOff(value) {
    return formatBoolean(value, 'On', 'Off');
}

export default formatBoolean;
